export default __webpack_public_path__ + "static/media/icon_list.24a54fb7.svg";